import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';

const isStreamVideo = (videoUrl: string) => getExtensionFromPath(videoUrl) === 'm3u8';

export default isStreamVideo;
